<div class="lum-c-order-refund-return-orders-ag-table">
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner">Loading...</div>
  </div>

  <ag-grid-angular
    style="width: 100%; height: 500px"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
